import React from "react";

function UPButton() {
  return (
    <a
      href="#home"
      style={{
        position: "fixed",
        right: "20px",
        bottom: "20px",
        height: "50px",
        width: "50px",
        backgroundColor: " #2b914c",
        borderRadius: "50%",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        textDecoration: "none",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = " #2b914c";
        e.target.style.transform = "scale(1.1)";
        e.target.style.boxShadow = "0 4px 15px rgba(0, 128, 0, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = " #2b914c";
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow = "none";
      }}
    >
      <svg
        width="34"
        height="34"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: "none" }}
      >
        <path
          d="M50 100 L100 50 L150 100"
          stroke="white"
          stroke-width="14"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M50 140 L100 90 L150 140"
          stroke="white"
          stroke-width="14"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </svg>
    </a>
  );
}

export default UPButton;